import { PackingListPage } from './PackingListPage';

export default PackingListPage;
